<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Kategorie</v-flex>

        <v-spacer />

        <v-flex>
          <search />
        </v-flex>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="CATEGORY.ADD">
            <v-btn large color="error" @click="showAddModal">DODAJ KATEGORIĘ</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        entity-type="category"
        :headers="table.headers"
        :actions="actions"
        :items="list"
        :total-count="count"
        @add="showAddModal"
        @edit="showEditModal($event.id)"
        @delete="showDeleteDialog($event.id)"
      />

      <material-dialog
        title="Potwierdź usunięcie"
        text="Czy na pewno chcesz usunąć kategorię? Usunięcie kategorii spowoduje ukrycie wszystkich przypisanych usług"
        :show="!!idToDelete"
        :id="idToDelete"
        @close="hideDeleteDialog"
        @confirm="remove"
      />
    </material-card>

    <modal
      :show="showModal"
      :id="idToEdit"
      :edit="!!idToEdit"
      @close="hideModal"
      @save="addCategory"
      @update="updateCategory"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Search from '@/components/material/table/Search';
import { listMixin } from '@/mixins/list';
import { DELETE_ACTION, EDIT_ACTION } from '@/utils/actions';
import Modal from './addCategory.modal';

// @vuese
// Wyświetlanie listy kategorii
// @group Categories
export default {
  mixins: [
    listMixin('categories', {
      listError: 'Wystąpił błąd podczas pobierania listy kategorii.',
      getError: 'Wystąpił błąd podczas pobierania danych kategorii.',
      added: 'Dodano kategorię.',
      addError: 'Nie udało się dodać kategorii.',
      updated: 'Zaktualizowano dane kategorii.',
      updateError: 'Nie udało się zaktualizować danych kategorii.',
      deleted: 'Usunięto kategorię.',
      deleteError: 'Nie udało się usunąć kategorii.'
    })
  ],
  components: {
    MaterialCard,
    MaterialDialog,
    MaterialTable,
    Modal,
    Search
  },
  methods: {
    // @vuese
    // Odświeża listę po dodaniu kategorii
    afterAdd() {
      this.reloadList(this.$route);
    },
    // @vuese
    // Odświeża listę po aktualizacji kategorii
    afterUpdate() {
      this.reloadList(this.$route);
    },
    // @vuese
    // Dodaje kategorię
    addCategory(data) {
      this.add({ category: { name: data.name } });
    },
    // @vuese
    // Aktualizuje kategorię
    updateCategory(data) {
      this.update({ category: { name: data.name }, id: data.id });
    }
  },

  data() {
    return {
      table: {
        headers: [{ value: 'name', text: 'Nazwa kategorii', sortable: true }]
      },
      actions: [DELETE_ACTION, EDIT_ACTION]
    };
  }
};
</script>
